import React, { useEffect, useMemo, useState } from "react";
import useForm from "../app/hooks/useForm";
import Input from "../comman/input";
import Select from "../comman/select";
import PhoneInput from "../comman/PhoneInput";
import geo from "../services/geoService";

const buildProfileData = (userDetails) => {
  if (!userDetails || userDetails === "") return {};

  return {
    performerid: userDetails.performerid,
    performername: userDetails.performername,
    performeremail: userDetails.performeremail,
    userName: userDetails.userName,
    contactNo: userDetails.contactNo,
    location: userDetails.location,
    state: userDetails.state,
    county: userDetails.county,
    lastName: userDetails.lastName,
    zipCode: userDetails.zipCode,
  };
};

const MyProfileDetails = ({
  userDetails,
  handleSubmit: submitProfile,
  profileEdit,
  setProfileEdit,
}) => {
  const schema = useMemo(() => ({}), []);
  const [stateList, setStateList] = useState([]);

  const doSubmit = () => {
    submitProfile(stateData);
    setProfileEdit(false);
  };

  const {
    stateData,
    setStateData,
    stateErrors,
    handleChange,
    handleSubmit,
  } = useForm(schema, doSubmit);

  useEffect(() => {
    let isMounted = true;

    const loadProfileFormData = async () => {
      if (!userDetails || userDetails === "") return;

      const states = await geo.getStateList();

      if (isMounted) {
        setStateData(buildProfileData(userDetails));
        setStateList(states || []);
      }
    };

    loadProfileFormData();

    return () => {
      isMounted = false;
    };
  }, [userDetails, setStateData]);

  const handleCancel = () => {
    setStateData(buildProfileData(userDetails));
    setProfileEdit(false);
  };

  const renderInput = (name, label, type = "text", icon) => {
    if (type === "phone") {
      return (
        <PhoneInput
          name={name}
          value={stateData[name] || ""}
          label={label}
          onChange={handleChange}
          error={stateErrors[name]}
          req={schema[name]}
          icon={icon}
        />
      );
    }

    return (
      <Input
        type={type}
        name={name}
        value={stateData[name] || ""}
        label={label}
        onChange={handleChange}
        error={stateErrors[name]}
        req={schema[name]}
        icon={icon}
      />
    );
  };

  const renderSelect = (name, label, options, optName, optValue, icon) => (
    <Select
      name={name}
      value={stateData[name] || ""}
      label={label}
      options={options}
      onChange={handleChange}
      error={stateErrors[name]}
      optName={optName}
      optValue={optValue}
      req={schema[name]}
      icon={icon}
    />
  );

  return (
    <React.Fragment>
      <fieldset disabled={!profileEdit}>
        <div className="row">
          <div className="col-lg-6">
            {renderInput("performername", "Full Name", "text", "fa-user")}
          </div>
          {/* <div className="col-lg-6">
            {renderInput("lastName", "Last Name")}
          </div> */}
          <div className="col-lg-6">
            {renderInput("contactNo", "Phone No.", "phone", "fa-phone")}
          </div>
          <div className="col-lg-6">
            {renderInput("performeremail", "Email", "text", "fa-envelope")}
          </div>
          <div className="col-lg-12 form-group">
            <label className="form-control-label mr-2">
              Choose a way to verify
            </label>
            (<span className="text-red">You'll need to confirm that it's yours.
              Select how you'd like to get a verification code.</span>)
            <div className="d-flex">
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  id="verifyByEmail"
                  type="checkbox"
                />
                <label className="custom-control-label mr-3" htmlFor="verifyByEmail">
                  Email
                </label>
              </div>
              <div className="custom-control custom-checkbox">
                <input
                  className="custom-control-input"
                  id="verifyByPhone"
                  type="checkbox"
                />
                <label className="custom-control-label" htmlFor="verifyByPhone">
                  Phone No.
                </label>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-6">
            <fieldset disabled={true}>
              {renderInput("userName", "Username")}
            </fieldset>
          </div> */}
          <div className="col-md-12">
            {renderInput("location", "Address Line 1", "text", "fa-map-marker")}
          </div>
          <div className="col-md-4">
            {renderSelect(
              "state",
              "State",
              stateList,
              "name",
              "name",
              "fa-globe"
            )}
          </div>
          <div className="col-md-4">
            {renderInput("county", "City", "text", "fa-building")}
          </div>
          <div className="col-md-4">
            {renderInput("zipCode", "Zip Code", "text", "fa-map-pin")}
          </div>
          <div className="col-md-12 text-center form-group">
            {profileEdit && (
              <div className="rt-profile-form-actions">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-default"
                  onClick={handleCancel}
                >
                  <i className="fa fa-times" aria-hidden="true"></i> Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-default"
                  onClick={() => handleSubmit()}
                >
                  <i className="fa fa-pencil" aria-hidden="true"></i> Update
                </button>
              </div>
            )}
          </div>
        </div>
      </fieldset>
    </React.Fragment>
  );
};

export default MyProfileDetails;
